<template>
  <img :src="path" :alt="alt" :class="cssClass" />
</template>
<script>
import Path from '../../mixins/Path.vue';
export default {
  name: 'ImageTag',
  mixins: [Path],
  props: {
    alt: {
      type: String,
      required: true,
    },
    cssClass: {
      type: String,
      default: null,
    },
  },
};
</script>
